<template>
    <section class="font-poppins text-sm">
        <div >
            <div>
                <section class=" mt-10">
                    <div class="text-sm flex justify-between md:flex-col">
                        <div class="flex md:flex-col">
                            <div class="text-xl font-bold flex md:mt-6">
                                <div>
                                    <p>Order List
                                        <i v-if="isLoading" class="fa fa-spinner fa-spin  ml-4 text-blue-600"></i>
                                    </p>
                                    
                                </div>         
                            </div>
                            <div class="flex md:flex-col">
                                <!-- <router-link to="" class="font-bold p-2 text-white rounded ml-3 md:w-1/2 md:mb-1 md:ml-0"  style="background-color:#0048AE">Create an Order</router-link > -->
                                <router-link to="/admin/track-order"><p class="font-bold p-2 text-white rounded ml-3 md:w-1/2 md:mb-1 md:ml-0" style="background-color:#0048AE">Track an Order</p></router-link >
                            </div>
                        </div>

                        <div >
                            
                            <input v-model="searchQuery" @click="search = !search" class="border outline-none w-72 p-2 rounded-lg bg-gray-100 text-xs" type="text" name="search" id="search" placeholder="Search name, email...">
                            <i class="fa fa-search -ml-10 md:hidden mt-2"></i>
                            <div class="mt-4">
                                <div>
                                        <label class="text-blue-600 text-xs" for="start Date">Choose start Date</label>
                                        <input class="border pl-2 pr-2 ml-2" type="date" placeholder="Start Date" v-model="startDate">
                                </div>
                                <div class="mt-1">
                                        <label class="text-blue-600 text-xs" for="start Date">Choose end Date</label>
                                        <input class="border pl-2 pr-2 ml-3" type="date" placeholder="End Date" v-model="endDate">
                                </div>
                                <div class="text-right text-sm mt-1">
                                    <button class="text-white bg-blue-500 w-10 rounded-sm" @click="dateSearch">GO</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div v-show="orderList">
                    <div class="md:overflow-x-auto">
                        <table class="w-full mt-8">
                            <tbody>
                                <tr class="text-left border-b-2">
                                    <th>Customer Name</th>
                                    <th>Phone Number</th>
                                    <th>Pickup Address</th>
                                    <th>Delivery Address</th>
                                    <th>Status</th>
                                    <th>Tracking No</th>
                                    <th>Order Type</th>
                                    <th>Order Date</th>
                                </tr>
                                
                                <tr v-for="order in filterName" :key="order" class="hover:bg-gray-300 hover:border  hover:border-blue-700 border-b-2">
                                    <td class="w-40" >{{order.customerName}}</td>
                                    <td class="w-40" >{{order.customerPhoneNumber}}</td>
                                    <td class="w-40" >{{order.pickupAddress}}</td>
                                    <td class="text-blue-700  w-40" >{{order.deliveryAddress[0].address}}</td>
                                    <td class=" text-blue-500 w-40"> 
                                        <span v-if="order.status == 'processing' " class=" mr-1 processing"><i class="fa fa-circle mr-1"></i>{{order.status}}</span>
                                        <span v-if="order.status == 'completed' " class=" mr-1 completed"><i class="fa fa-circle mr-1"></i>{{order.status}}</span>
                                        <span v-if="order.status == 'canceled' " class=" mr-1 text-red-500"><i class="fa fa-circle mr-1"></i>{{order.status}}</span>
                                    </td>
                                    <td  class="w-40" >{{order.trackingNumber}}</td>
                                    <td class="w-40">{{order.orderType}}</td>
                                    <td class="w-40">
                                        {{moment(order.updated_at).format('DD/MM/YYYY')}}</td>
                                        <td>
                                        <span @click="toggleList(order)" class=" fa fa-ellipsis-v ml-3 text-gray-500 cursor-pointer"></span>
                                        <div v-if="order.status === 'processing'" class="relative">
                                            <ul class="absolute text-xs bg-gray-50 text-blue-700 pt-4 pb-4 pl-2 pr-2" v-show="order.navList">
                                                <router-link :to="{name: 'reassign-order', params: {id: order._id, trackNumber:order.trackingNumber, name:order.customerName, number:order.customerPhoneNumber}}" >
                                                    <li class="border-b-2 cursor-pointer">Re-assign Task</li>
                                                </router-link>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    

                    <div v-if="!searchQuery" class="flex justify-between mt-10 text-gray-500 md:flex-col">
                        <div  class="md:text-xs">
                            <p>Showing {{currentPage}} of {{totalPages}} Pages of {{totalList}} Orders </p>
                        </div>

                        <div class="flex ">
                            <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                            <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        

        <div v-show="showSearchDate">
            <div>
            <div class="md:overflow-x-auto">
                {{record}}
                <table class="w-full mt-8">
                    <tbody>
                        <tr class="text-left border-b-2">
                            <th>Customer Name</th>
                            <th>Phone Number</th>
                            <th>Pickup Address</th>
                            <th>Delivery Address</th>
                            <th>Status</th>
                            <th>Tracking No</th>
                            <th>Order Type</th>
                            <th>Order Date</th>
                        </tr>
                        
                        <tr v-for=" order in filterNameSearch" :key="order" class="hover:bg-gray-300 hover:border  hover:border-blue-700 border-b-2">
                            <td class="w-40" >{{order.customerName}}</td>
                            <td class="w-40" >{{order.customerPhoneNumber}}</td>
                            <td class="w-40" >{{order.pickupAddress}}</td>
                            <td class="text-blue-700  w-40" >{{order.deliveryAddress[0]}}</td>
                            <td class=" text-blue-500 w-40"> 
                                <span v-if="order.status == 'processing' " class=" mr-1 processing"><i class="fa fa-circle mr-1"></i>{{order.status}}</span>
                                <span v-if="order.status == 'completed' " class=" mr-1 completed"><i class="fa fa-circle mr-1"></i>{{order.status}}</span>
                                <span v-if="order.status == 'canceled' " class=" mr-1 text-red-500"><i class="fa fa-circle mr-1"></i>{{order.status}}</span>
                            </td>
                            <td  class="w-40" >{{order.trackingNumber}}</td>
                            <td class="p-1">{{order.orderType}}</td>
                            <td class="w-40">
                                {{moment(order.updated_at).format('DD/MM/YYYY')}}</td>
                                <td>
                                <span @click="toggleList(order)" class=" fa fa-ellipsis-v ml-3 text-gray-500 cursor-pointer"></span>
                                <div class="relative">
                                    <ul class="absolute text-xs bg-gray-50 text-blue-700 pt-4 pb-4 pl-2 pr-2" v-show="order.navList">
                                        <router-link :to="{name: 'reassign-order', params: {id: order._id, trackNumber:order.trackingNumber, name:order.customerName, number:order.customerPhoneNumber}}" >
                                            <li class="border-b-2 cursor-pointer">Re-assign Task</li>
                                        </router-link>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

            <p class="mt-10 text-gray-500"> Showing {{searchLength}} Search Results</p>
        <div v-if="!searchQuery" class="flex justify-between mt-4  md:flex-col">
            <div class="md:text-xs">
                <p>Showing {{currentPage}} of {{totalPages}} Pages of {{page1}} Orders </p>
            </div>

            <div class="flex ">
                <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                <button @click="nextSearch" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
            </div>
        </div>
        </div>
    </section>
</template>


<script>
import moment from 'moment';
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            filter: '',
            navList: false,
            orders : [],
            isLoading: false,
            page:1,
            search: null,
            selectedName: null,
            showFilter: true,
            searchQuery : '',
            totalList: "",
            page1: 20,
            startDate: "",
            endDate: "",
            orderList: true,
            showSearchDate: false,
            record: "",
            searchOrders: [],
            currentPage:1,
            pageSize:20,
            searchLength: "",
            totalPages: "",
        }
    },

    mounted() {
        this.getOrders();
        this.networkError();
    },

    computed: {
        filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.orders.filter((theOrder) => {  
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.orders.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.orders.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                if(index >= start && index < end) return true;
                })
            }
            
        },

        filterNameSearch() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.searchOrders.filter((theOrder) => {
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.searchOrders.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.searchOrders.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                if(index >= start && index < end) return true;
                })
                // return this.orders
            }
            
        },
        //  sortedList:function() {
        //  }
    },

    methods: {
        toggleList(order) {
            order.navList = !order.navList
        },

        dateSearch() {
            this.isLoading = true;
            let startDate = moment(this.startDate).format("DD-MM-YYYY");
            let endDate = moment(this.endDate).format("DD-MM-YYYY");
            axios({
                method: 'GET',
                url: `${url}/v1/web/orders?&startDate=${startDate}&endDate=${endDate}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.isLoading = false
                this.showSearchDate = true;
                this.orderList = false;
                this.searchOrders = response.data.data.results;
                if(this.searchOrders.length <= 0) {
                    this.record = "No Record found"
                }
                this.page1 = this.searchOrders.length;
                this.totalOrders = response.data.data.totalResults;
                this.searchLength = this.searchOrders.length
            })
            .catch((error) => {
                this.isLoading = false;
                error.json;
            })
        },

        moment(date) {
            return moment(date);
        },

        showDetails(eachUser) {
            this.selectedName = eachUser;
            this.showFilter = false
            this.getOrders()
        },

        next() {
            if((this.currentPage*this.pageSize) < this.orders.length) this.currentPage++;
        },

        prev() {
            if(this.currentPage > 1) this.currentPage--
        },

        nextSearch() {
            if((this.currentPage*this.pageSize) < this.searchOrders.length) this.currentPage++;
        },

        

        getOrders() {
            this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/orders?sortBy=name`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.isLoading = false
                this.orders = response.data.data.results;
                if(this.orders < 20) {
                    this.page1 = this.orders.length;
                }
                this.totalList = response.data.data.meta.totalResults;
            })
            .catch((error) => {
                error.json;
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.processing {
    color: rgb(243, 243, 9);
}

.completed{color: green;}

</style>
